import { Link } from "react-router-dom";
export default function Footer() {
  return (
    <div className="footer-container">
      <div className="copyright">Copyright (c) 2023. Mongoro</div>

      <div className="links">
        <Link to={"https://mongoro.com/terms-condition"} target="blank">
          Terms of Use
        </Link>{" "}
        |{" "}
        <Link to={"https://mongoro.com/privacy-policy"} target="blank">
          Privacy Policy
        </Link>
      </div>
    </div>
  );
}
